import React, { useEffect, useRef, useState } from 'react';
import ApexCharts from 'apexcharts';
import TauriSectionModalVisual from '../../TauriSectionBaseVisual/TauriSectionModalVisual/TauriSectionModalVisual';
import TauriSectionModalMultiVisual from '../../TauriSectionBaseVisual/TauriSectionModalMultiVisual/TauriSectionModalMultiVisual';
import setting from '../../../config.json';

const OpalGuageVisual = ({ chartConfig, chartData, chartOptions, columnSize, rowSize, palettes, themes, chartPalettes }) => {
    const chartRef = useRef(null);
    const [selectedVisual, setSelectedVisual] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        if (!chartData) return;

        const handleDataPointSelection = (event, chartContext, config) => {
            const selectedSliceIndex = config.dataPointIndex;
            const title = chartConfig.binding.context.point.onClick.selectedValueColumn;
            const modalTitle = chartConfig.binding.context.point.onClick.selectedTitle;
            const selectedDesc = chartData[selectedSliceIndex][chartConfig.binding.data.title];
            const selectedVal = chartData[selectedSliceIndex][title];
            const selectedTitle = chartConfig.title;

            if (chartConfig.binding.context.point.onClick.visual || Array.isArray(chartConfig.binding.context.point.onClick.visuals)) {
                let selectedVisual = null;
                if (chartConfig.binding.context.point.onClick.visuals) {
                    selectedVisual = chartConfig.binding.context.point.onClick.visuals;
                } else {
                    selectedVisual = chartConfig.binding.context.point.onClick.visual;
                }

                setSelectedVisual(selectedVisual);
                setSelectedData({ title, selectedDesc, selectedVal, selectedTitle, modalTitle });

                const tauriElement = document.querySelector('.tauri-host-container');
                if (tauriElement) {
                    if (event) {
                        const { left, top, right, bottom } = tauriElement.getBoundingClientRect();
                        let posX = event.clientX;
                        let posY = event.clientY;
                        if ((event.clientX + setting.modalMinWidth) > window.innerWidth) {
                            posX = event.clientX - setting.modalMinWidth;
                        }
                        if ((event.clientY + setting.modalMinHeight) > window.innerHeight) {
                            posY = event.clientY - setting.modalMinHeight;
                        }

                        setModalPosition({ x: posX, y: posY });
                    }
                }
            }
        };

        const options = {
            chart: {
                ...chartOptions.chart,
                toolbar: {
                    show: true,
                    tools: {
                        download: true
                    }
                },
                events: {
                    dataPointSelection: handleDataPointSelection,
                }
            },
            plotOptions: chartOptions.plotOptions,
            legend: chartOptions.legend,
            labels: chartData.map(item => {
                const progress = item[chartConfig.binding.data.value];
                const total = item[chartConfig.binding.data.total];
                return `${progress}/${total}`;
            }),
            series: chartData.map(item => {
                const progress = item[chartConfig.binding.data.value];
                const total = item[chartConfig.binding.data.total];
                return total > 0 ? Math.round((progress / total) * 100) : 0;
            }),
            colors: chartData.map(item => item[chartConfig.binding.data.value] < 50 ? chartPalettes[0].ranges[0] : chartPalettes[0].ranges[0]),
        };

        const chart = new ApexCharts(chartRef.current, options);

        chart.render();

        return () => {
            chart.destroy();
        };
    }, [chartConfig, chartData]);

    return (
        <>
            <div className='chart-content' >
                <div ref={chartRef} className="apex-wrapper"/>
            </div>
            {selectedVisual && (
                chartConfig.binding.context.point.onClick.visuals ? (
                    <TauriSectionModalMultiVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                ) : (
                    <TauriSectionModalVisual
                        show={selectedVisual !== null}
                        onHide={() => setSelectedVisual(null)}
                        selectedData={selectedData}
                        visual={selectedVisual}
                        columnSize={columnSize}
                        rowSize={rowSize}
                        style={{ top: modalPosition.y, left: modalPosition.x }}
                        palettes={palettes}
                        themes={themes}
                    />
                )
            )}
        </>
    );
};

export default OpalGuageVisual;
